/**
 * calc/dateIndex.ts — the two binary searches over an ascending
 * 'YYYY-MM-DD' array, shared by the price forward-fill (priceBook), the FX
 * forward-fill (fx) and the flow→date-axis snapping (equityCurve, the chart
 * pipeline). Pure index mechanics: what a miss (-1) means — null price,
 * earliest rate, dropped flow — stays with the caller.
 */

/** Greatest index with dates[i] <= target, or -1 when target precedes all. */
export function lastIndexOnOrBefore(dates: string[], target: string): number {
  let lo = 0, hi = dates.length - 1, ans = -1;
  while (lo <= hi) {
    const mid = (lo + hi) >> 1;
    if (dates[mid] <= target) { ans = mid; lo = mid + 1; }
    else hi = mid - 1;
  }
  return ans;
}

/** Smallest index with dates[i] >= target, or -1 when target follows all. */
export function firstIndexOnOrAfter(dates: string[], target: string): number {
  let lo = 0, hi = dates.length - 1, ans = -1;
  while (lo <= hi) {
    const mid = (lo + hi) >> 1;
    if (dates[mid] >= target) { ans = mid; hi = mid - 1; }
    else lo = mid + 1;
  }
  return ans;
}
